import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";

export const redblueActivityCreatePageMessages: Record<AppLocale, MessageTree> = {
  "zh-CN": {
    redblue: {
      pages: {
        activityCreate: {
          title: "新建演练活动",
          subtitle: "在独立创建窗口中完成 4 步配置，完成后活动列表会自动刷新。",
        },
      },
    },
  },
  en: {
    redblue: {
      pages: {
        activityCreate: {
          title: "Create Exercise Activity",
          subtitle:
            "Finish the four-step flow in a dedicated creation window. The activity list refreshes automatically when you return.",
        },
      },
    },
  },
  ja: {
    redblue: {
      pages: {
        activityCreate: {
          title: "演習活動を作成",
          subtitle:
            "独立した作成ウィンドウで 4 ステップを完了します。戻ると一覧は自動的に更新されます。",
        },
      },
    },
  },
};
